import CustomStore from 'devextreme/data/custom_store'
import { axiosInstance } from '@/http-common'
import jQuery from 'jquery'
import { getHumanDateTimeFromDateTime } from '@/utils/tools'
import i18n from '@/i18n'
import { AxiosResponse } from 'axios'

const $ = jQuery
const { t } = i18n.global || i18n

function isNotEmpty(value) {
    return value !== undefined && value !== null && value !== ''
}

const store = new CustomStore({
    cacheRawData: false,
    key: 'id',
    totalCount: () => {
        const d = new $.Deferred()
        const params = {
            needCount: false
        }
        params.needCount = true
        d.resolve(5000)
        return d.promise()
    },
    load: (loadOptions) => {
        const d = $.Deferred()

        let params = '?';
        [
            'skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'groupSummary'
        ].forEach(function (i) {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
                params += `${ i }=${ JSON.stringify(loadOptions[i]) }&`
            }
        })
        params = params.slice(0, -1)

        axiosInstance.get(`/api/v1/tacho/done/list${ params }`)
            .then((response: AxiosResponse) => {
                response.data.data.result.forEach(function (obj) {
                    obj.updated_at = getHumanDateTimeFromDateTime(obj.updated_at)

                    if (obj.type == 2)
                        obj.type = t('components.tachographFiles.dataGrids.driverCardFile1')
                    else if (obj.type == 4)
                        obj.type = t('components.tachographFiles.dataGrids.driverCardFile2')
                    else
                        obj.type = t('components.tachographFiles.dataGrids.tachographFile')
                })
                d.resolve(response.data.data.result, { totalCount: response.data.totalCount })
            })
        return d.promise()
    }
})

export function getStore(): CustomStore {
    return store
}